import * as yup from "yup";

export const CertQuerySchemaStep1 = yup
  .object({
    rut: yup
      .string()
      .required("El RUT es requerido.")
      .test(
        "len",
        "El RUT no es válido o no pertenece a una persona natural.",
        (value) => {
          if (value === undefined) {
            return true;
          }

          return new RegExp(/^\d{1,2}\.\d{3}\.\d{3}-(\d|k)$/, "i").test(value);
        }
      ),
    email: yup
      .string()
      .required("El correo es requerido.")
      .email("El correo no es válido."),
  })
  .required();

export const CertQuerySchemaStep2 = yup
  .object({
    email: yup
      .string()
      .required("El correo es requerido.")
      .email("El correo no es válido."),
    code: yup
      .string()
      .required("El código es requerido.")
      .test("len", "El código no es válido.", (value) => {
        if (value === undefined) {
          return true;
        }
        return new RegExp(/^\w{5}$/).test(value);
      }),
  })
  .required();
